<template>
  <div class="home" :class="[active == 2 ? 'white' : '']">
    <div class="banner">
      <div class="logo">
        <img src="../assets/logo.png" class="logoimg">
        <img src="../assets/kerongwanghu.svg" class="kerong">
      </div>
      <div class="label">
        <div class="index" v-for="(i, k) in taps" :key="k" :class="k == active ? 'active' : ''" @click="switchTab(k)">
          {{ i.label }}
        </div>
      </div>
      <div class="kefu">
        <div class="kefurcode">
          <img src="../assets/kefu.png" class="kefucode">
        </div>
        <img src="../assets/kefubt.png" />
      </div>
    </div>
    <div class="combox">
      <!-- <component :is="currentComponent"></component> -->
      <router-view />
    </div>
    <div class="bottombanner">
      <div class="record"><img src="../assets/logo.png" class="logo" />Copyright ©2023 贵州科融万户科技集团有限公司 <a
          href="https://beian.miit.gov.cn/#/Integrated/index">黔ICP备2023004901号</a>
      </div>
    </div>
  </div>
</template>

<script>
import index from '@/page/home/index.vue'
import contact from '@/page/contact/index.vue'
import product from '@/page/product/index.vue'
export default {
  name: 'HelloWorld',
  data() {
    return {
      active: 0,
      taps: [{
        label: '首页',
        value: 0
      }, {
        label: '关于我们',
        value: 1
      }, {
        label: '联系我们',
        value: 2
      }],
      currentComponent: 'product'
    }
  },
  components: {
    index, contact, product
  },
  methods: {
    switchTab(i) {
      this.active = i
      // this.currentComponent = ['product', 'index', 'contact'][i]
      let router = ['/home', '/about', '/contact']
      this.$router.push({ path: router[i] })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  background-image: url('static/bg.png');
  background-repeat: no-repeat;
  background-size: 1520px 769px;

  &.white {
    background: #fff;
  }

  .combox {
    width: 100%;
  }

  .banner {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;

    .logo {
      display: flex;
      align-items: center;
      position: relative;

      .logoimg {
        width: 30px;
        height: 32px;
      }

      .kerong {
        width: 167px;
        height: 32px;
        // background-image: url('../assets/kerongwanghu.png');
        // background-size: 167px 32px;
      }
    }

    .label {
      display: flex;

      .index {
        color: #888888;
        font-size: 16px;
        // width: 220px;
        cursor: pointer;
        padding-right: 80px;

        &.active {
          color: #3BBAD3;
        }
      }
    }

    .kefu {
      padding-top: 23px;
      cursor: pointer;
      position: relative;

      &:hover {
        .kefurcode {
          visibility: visible;
        }
      }

      .kefurcode {
        visibility: hidden;
        background: #fff;
        position: absolute;
        top: 115px;
        left: -20px;
        padding: 10px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        box-shadow: 1px 1px 12px rgba(115, 115, 115, .5);

        &::after {
          content: '';
          border-left: 10px solid transparent;
          border-bottom: 10px solid #fff;
          border-right: 10px solid transparent;
          width: 0;
          height: 0;
          position: absolute;
          top: -10px;
        }
      }

      img {
        width: 116px;
      }

      // width: 196px;
      // height: 88px;
      // background-image: url('../assets/kefubt.png');
      // // background-size: 116px 48px;
      // background-repeat: no-repeat;
    }
  }

  .bottombanner {
    border-top: 1px solid #E0E0E0;
    height: 50px;
    width: 70%;
    text-align: center;
    padding-top: 15px;
    margin-top: 50px;

    .record {
      color: #C7C7C7;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .logo {
        width: 11px;
        height: 12px;
        margin-right: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue